<template>
  <layout title="Pricing" :transparent="true" class="overflow-x-hidden">
    <highlightSection
      backgroundImage="/storage/images/pricing/youverse_authentication_pricing.jpg"
      altImage="Youverse Authentication Pricing"
      title="Pricing plans to fit your business needs."
      subtitle="Cost-effective, customizable solutions for businesses of all sizes. Standalone solution or full suite? You choose."
      :imageLeft="true"
    />
    <prices :errors="errors" />

    <section1 :errors="errors" />
    <FeatureHighlightSection :features="features" title="All plans include" />
    <div class="py-14">
      <textImageSection
        title="Get more information about integrating our APIs"
        text="Connect YouAuth with the most popular identity providers"
        imageSrc="/storage/images/pricing/face_matching_api.png"
        imageAlt="Biometric Authentication Id Verification"
        buttonText="Developer Documentation"
        buttonLink="/docs"
        :imageLeft="false"
        :target="true"
      />
    </div>

    <div class="md:pt-14">
      <cta
        title="Get started"
        text="Your competitors are already ahead. Are you ready?"
        buttonText="Book a Demo"
        buttonLink="/book-a-meeting"
        target="_blank"
      />
    </div>

    <section2 />
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "./../Components/Layout/layout.vue");

const highlightSection = () =>
  import(
    /* webpackChunkName: "highlightSection" */ "./../Components/Layout/highlightSection.vue"
  );

const prices = () =>
  import(
    /* webpackChunkName: "prices" */ "./../Components/Layout/Pricing/prices.vue"
  );

const section1 = () =>
  import(
    /* webpackChunkName: "section1" */ "./../Components/Layout/Pricing/section1.vue"
  );

const cta = () =>
  import(/* webpackChunkName: "cta" */ "./../Components/Layout/cta.vue");

const FeatureHighlightSection = () =>
  import(
    /* webpackChunkName: "FeatureHighlightSection" */ "../Components/Layout/UseCases/FeatureHighlightSection.vue"
  );

const section2 = () =>
  import(
    /* webpackChunkName: "section1" */ "./../Components/Layout/Pricing/section2.vue"
  );

const textImageSection = () =>
  import(
    /* webpackChunkName: "textImageSection" */ "../Components/Layout/textImageSection.vue"
  );

export default {
  components: {
    layout,
    highlightSection,
    prices,
    section1,
    textImageSection,
    cta,
    section2,
    FeatureHighlightSection,
  },
  props: {
    errors: Object,
  },

  data() {
    return {
      features: [
        {
          title: "Cloud or self-hosted",
          description: "Docker containers to deploy on your servers.",
          image: "/storage/images/pricing/id_verification_cloud.png",
        },
        {
          title: "Full admin access",
          description:
            "Dedicated user dashboard to manage subscription and monitor consumptions.",
          image: "/storage/images/pricing/id_verification_subscription.png",
        },
        {
          title: "Integration SDKs",
          description:
            "Easy to integrate native SDK in popular proeminient languages.",
          image: "/storage/images/pricing/id_verification_sdk.png",
        },
      ],
    };
  },
};
</script>

